export default __webpack_public_path__ + "static/media/Connecticut3Closed.fc965a4d.jpg";